import { render, staticRenderFns } from "./portallabel.vue?vue&type=template&id=d3b844a6&scoped=true&"
import script from "./portallabel.vue?vue&type=script&lang=js&"
export * from "./portallabel.vue?vue&type=script&lang=js&"
import style0 from "./portallabel.vue?vue&type=style&index=0&id=d3b844a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b844a6",
  null
  
)

export default component.exports